import React, { useEffect, useState } from "react";
import YhSelect from "../../../../../ui/YhSelect";
import YhButton from "../../../../../ui/YhButton";
import { updateUploadLead } from "./EmployeeDocumentServices";
import {
  isTruthy,
  openErrorNotification,
  openSuccessNotification,
} from "../../../../../helpers/methods";
import notifiers from "../../../../../global/constants/NotificationConstants";
import customErrorHandler from "../../../../../utils/customErrorHandler";
import { useStepper } from "../../exportLead/StepperContext";
import { getAllSource } from "../../ShowAll/ShowAllService";

interface CustomProps {
  nextStep?: () => void | undefined;
  backStep?: () => void | undefined;
  fromSettingOrLogout?: any;
  userId: String;
  handleCloseAddTeam: any;
  registerStepActions?: (actions: { submit: () => void | Promise<void> }) => void;
  hideFooterButtons?: boolean;
}

const EmployeeDocuments = (props: CustomProps) => {
  const { stepperProps } = useStepper();
  const [dropdownValues, setDropdownValues] = useState<string[]>([]);
  const [sourceData, setSourceData] = useState<string[]>([]);
  const [fileUrls, setFileUrls] = useState<string[]>([]);

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const init = async () => {
    const val = stepperProps?.data?.[0];
    const fields = val?.dynamicFields || [];
    const data = fields.map((e: any) => e.name);

    try {
      const response = await getAllSource();
      setSourceData(response.data.map((item: any) => item.source_name));
    } catch {
      /* ignore */
    }

    setFileUrls([
      "lead_name",
      "lead_email",
      "lead_phone",
      "lead_source",
      "lead_project",
      ...data,
    ]);
  };

  const checkSource = () => {
    const allowed = new Set(sourceData || []);
    if (stepperProps?.subSource) allowed.add(String(stepperProps.subSource));
    let isCorrect = true;
    stepperProps.fileData?.map((item: any) => {
      if (!allowed.has(item.lead_source)) {
        isCorrect = false;
      }
    });
    return isCorrect;
  };

  const submitForm = async () => {
    if (!checkSource()) {
      openErrorNotification("Source  name in file is incorrect");
      return;
    }

    const mapping_info = dropdownValues?.map((item: any, index: any) => {
      return {
        [item]: stepperProps.headers[index],
      };
    });

    const body = {
      upload_file_name: stepperProps.fileName,
      file_path: stepperProps.imagePath?.imageUrl,
      mapping_info: mapping_info || "",
      uploadLeadId: stepperProps.uploadLeadId,
    };

    try {
      const response = await updateUploadLead(body);
      customErrorHandler(response);
      openSuccessNotification(response?.message);
      props.handleCloseAddTeam();
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  useEffect(() => {
    props.registerStepActions?.({ submit: submitForm });
  });

  const handleChange = (index: number) => (event: any) => {
    const newDropdownValues = [...dropdownValues];
    newDropdownValues[index] = event.target.value;
    setDropdownValues(newDropdownValues);
  };

  const fieldOptions = (fileUrls || []).map((e) => ({
    label: e,
    value: e,
  }));

  return (
    <div className="flex flex-col gap-5">
      <div>
        <h2 className="text-lg font-semibold text-[#111827]">Field Mapping</h2>
        <p className="mt-1 text-sm text-[#6B7280]">
          Map each CSV header to the matching lead field.
        </p>
      </div>

      <ol className="flex max-w-xl flex-col gap-4">
        {(stepperProps?.headers || []).map((item: any, i: number) => (
          <li key={`${item}-${i}`} className="list-decimal list-inside">
            <span className="mb-2 block text-sm font-medium capitalize text-[#111827]">
              {item}
            </span>
            <YhSelect
              placeholder="Select field"
              value={dropdownValues[i] || ""}
              onChange={handleChange(i)}
              options={fieldOptions}
            />
          </li>
        ))}
      </ol>

      {!stepperProps?.headers?.length ? (
        <p className="text-sm text-[#6B7280]">
          No headers found. Go back and upload a valid CSV.
        </p>
      ) : null}

      {!props.hideFooterButtons && (
        <div className="mt-2 flex justify-end gap-2">
          <YhButton variant="secondary" size="sm" onClick={props.backStep}>
            Back
          </YhButton>
          <YhButton variant="primary" size="sm" onClick={submitForm}>
            Submit
          </YhButton>
        </div>
      )}
    </div>
  );
};

export default EmployeeDocuments;
